import React from "react";
import { Link } from "react-router-dom";

const events = [
  {
    slug: "opening",
    logo: "/assets/img/logo/arsen2026-icon.png",
    code: "Opening",
    name: "Ceremony & Talkshow",
    description:
      "Pembuka rangkaian ARSEN 2026 dengan talkshow inspiratif seputar data dan statistika.",
    tagLabel: "Ceremony",
    border: "border-arsen-quaternary-950",
    tag: "bg-arsen-quaternary-100 text-arsen-quaternary-950",
    cta: "text-arsen-quaternary-950 group-hover:bg-arsen-quaternary-950",
  },
  {
    slug: "asec",
    logo: "/assets/img/logo/asec2026.svg",
    code: "ASEC",
    name: "Airlangga Statistics Essay Competition",
    description:
      "Kompetisi esai berbasis statistika untuk mahasiswa se-Indonesia.",
    tagLabel: "Essay · Mahasiswa",
    border: "border-arsen-secondary",
    tag: "bg-arsen-secondary-50 text-arsen-secondary",
    cta: "text-arsen-secondary group-hover:bg-arsen-secondary",
  },
  {
    slug: "asic",
    logo: "/assets/img/logo/asic2026.svg",
    code: "ASIC Siswa",
    name: "Airlangga Statistics Infographic Competition",
    description: "Kompetisi infografis nasional untuk siswa SMA/sederajat.",
    tagLabel: "Infographic · SMA",
    border: "border-arsen-primary",
    tag: "bg-arsen-primary-50 text-arsen-primary",
    cta: "text-arsen-primary group-hover:bg-arsen-primary",
  },
  {
    slug: "asic/mahasiswa",
    logo: "/assets/img/logo/asic2026.svg",
    code: "ASIC Mahasiswa",
    name: "Airlangga Statistics Infographic Competition",
    description: "Kompetisi infografis nasional untuk mahasiswa perguruan tinggi.",
    tagLabel: "Infographic · Mahasiswa",
    border: "border-arsen-primary-800",
    tag: "bg-arsen-primary-100 text-arsen-primary-800",
    cta: "text-arsen-primary-800 group-hover:bg-arsen-primary-800",
  },
  {
    slug: "aso",
    logo: "/assets/img/logo/aso2026.svg",
    code: "ASO",
    name: "Airlangga Statistics Olympiad",
    description: "Olimpiade statistika bergengsi untuk siswa SMA/sederajat.",
    tagLabel: "Olympiad · SMA",
    border: "border-arsen-tertiary",
    tag: "bg-arsen-tertiary-50 text-arsen-tertiary",
    cta: "text-arsen-tertiary group-hover:bg-arsen-tertiary",
  },
];

function EventsPage() {
  return (
    <div className="flex flex-col">
      {/* ── Header ── */}
      <section className="relative overflow-hidden bg-gradient-to-br from-white via-arsen-primary-50 to-arsen-sky-50 pt-12 pb-16 px-5 sm:px-8">
        <div className="absolute top-0 right-0 w-80 h-80 bg-arsen-primary-100 rounded-full opacity-30 blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none" />
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center md:items-end justify-between gap-6 relative z-10">
          <div data-aos="fade-up" className="flex flex-col items-center md:items-start text-center md:text-left">
            <span className="text-xs font-bold tracking-widest text-arsen-primary uppercase mb-2">
              Pilihan Cabang Kegiatan
            </span>
            <h1 className="text-4xl sm:text-5xl font-extrabold text-arsen-quaternary-950 leading-tight tracking-tight mb-3">
              Airlangga Statistics Events
            </h1>
            <p className="text-gray-500 text-sm sm:text-base max-w-lg">
              Lima cabang kegiatan ARSEN 2026 — pilih kompetisi yang paling sesuai denganmu.
            </p>
          </div>
          <img
            data-aos="fade-up"
            data-aos-delay="100"
            src="/assets/img/mascot/mascot4.svg"
            alt=""
            className="hidden sm:block w-28 h-auto shrink-0"
          />
        </div>
      </section>

      {/* ── Event Cards ── */}
      <section className="max-w-6xl mx-auto w-full px-5 sm:px-8 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {events.map((evt, i) => (
            <Link
              key={evt.slug}
              to={`/${evt.slug}`}
              onClick={() => window.scrollTo(0, 0)}
              data-aos="fade-up"
              data-aos-delay={i * 60}
              className={`group bg-white rounded-2xl shadow-sm border-t-4 ${evt.border} flex flex-col p-6 gap-4 hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 ease-out`}
            >
              <div className="flex items-center justify-between">
                <div className="w-12 h-12 rounded-xl bg-gray-50 border border-gray-100 flex items-center justify-center overflow-hidden shrink-0">
                  <img src={evt.logo} alt="" className="w-full h-full object-contain p-1.5" />
                </div>
                <span className={`text-[10px] font-bold tracking-widest px-2.5 py-1 rounded-full uppercase ${evt.tag}`}>
                  {evt.tagLabel}
                </span>
              </div>
              <div className="flex flex-col gap-1.5 flex-1">
                <h2 className="text-2xl font-extrabold text-arsen-quaternary-950">{evt.code}</h2>
                <p className="text-sm font-medium text-gray-500 leading-relaxed">{evt.name}</p>
                <p className="text-sm text-gray-400 leading-relaxed">{evt.description}</p>
              </div>
              <span
                className={`self-start flex items-center gap-1.5 text-xs font-bold px-4 py-2 rounded-lg border transition-all duration-200 group-hover:text-white group-hover:shadow-md ${evt.cta} border-current`}
              >
                Lihat Detail
                <svg className="w-3 h-3 group-hover:translate-x-0.5 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
                </svg>
              </span>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}

export default EventsPage;
